import { colors } from '@flowwai-frontend/shared/style-guide'

export const pipelineActivitiesTheme = {
   light: {
      common: {
         closeIconBGColor: colors['gray-500']
      },
      pipelineActivity: {
         plusIconColor: colors['base-white'],
         headerBorderColor: 'border-b-gray-300',
         headerTextColor: 'text-gray-900',
         eventNameTextColor: 'text-gray-700',
         templateNameTextColor: 'text-gray-700',
         createdAtTextColor: 'text-gray-600',
         pipelineActivityContainerBgColor: 'bg-gray-100',
         createPipeline: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600'
         },
         chevronLeftIconColor: colors['primary-600']
      },
      pipelineActivityTemplate: {
         checkIconColor: colors['primary-600'],
         bodyBackgroundColor: 'bg-gray-100',
         activityCardBgColor: 'bg-base-white',
         activityNameDescriptionTextColor: 'text-gray-700',
         activityDetailsTextColor: 'text-gray-600'
      },
      createActivity: {
         header: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600'
         }
      },
      activityDetailedView: {
         header: {
            titleColor: 'text-gray-900',
            chevronLeftIconColor: colors['primary-600'],
            backgroundColor: 'bg-base-white',
            refreshIconBg: '!bg-white',
            backIconColor: colors['gray-700']
         },
         backgroundColor: 'bg-gray-100'
      },
      configurationSettings: {
         header: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-700'
         },
         cardBackgroundColor: 'bg-base-white',
         IdsCardBorderColor: 'border-gray-300',
         idLabelColor: 'text-gray-500',
         idValueColor: 'text-gray-800',
         hrColor: 'bg-gray-300 border-gray-300',
         copyIconColor: colors['primary-600']
      }
   },
   dark: {}
}
